import { createStore } from "vuex"
import createPersistedState from "vuex-persistedstate"

const store = createStore({
  plugins: [
    createPersistedState({ storage: window.sessionStorage })
  ],
  state: {
    isLoading: false,
    sidebarStatus: false,
    tokenVerified: false,
    token: null,
    devices: [],
    searchStatus: false,
    tip: true,
    // fullScreenMap: false
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
  },
  mutations: {
    setInitialised(state, status) {
      state.initialised = status;
    },
    SET_SIDEBAR_STATUS(state, status) {
      state.sidebarStatus = status;
    },
    SET_SEARCH_STATUS(state, status) {
      state.searchStatus = status;
    },
    STORE_TOKEN_VERIFIED(state, token) {
      state.tokenVerified = true
      state.token = token
    },
    STORE_DEVICE_DATA(state, devices) {
      state.devices = devices
    },
    SET_LIFEPASS_TIP(state, status) {
      window.localStorage.setItem('tip', status);
      state.tip = status
    },
    SET_FULL_SCREEN_MAP(state, status) {
      state.fullScreenMap = status
    },
  },
  actions: {
    setSidebarStatus({ commit }, status) {
      commit('SET_SIDEBAR_STATUS', status);
    },
    setSearchStatus({ commit }, status) {
      commit('SET_SEARCH_STATUS', status);
    },
    setLifePassStatus({ commit }, status) {
      commit('SET_LIFEPASS_TIP', status);
    },
    // setFullScreenMapStatus({ commit }, status) {
    //   commit('SET_FULL_SCREEN_MAP', status);
    // },

    // Token
    storeAppAuthToken({ commit }, token) {
      return new Promise((resolve, reject) => {
        window.localStorage.setItem('token', token)
        if (!token) reject(new Error('no token'))
        resolve(commit('STORE_TOKEN_VERIFIED', token))
      })
    },
    
    // Devices
    getUserDevices({ commit }) {
      return this.axios
        .get(`${process.env.VUE_APP_API_BASE_URL}/api/app/device`)
        .then((res) => {
          commit('STORE_DEVICE_DATA', res)
          return res
        })
        .catch((error) => Promise.reject(error))
    },
  }
})

export default store